module.exports = __webpack_public_path__ + "static/oss-logo-dc875e9c2a7fa986058461593cf45626.svg";